import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" " + _vm._s(_vm.isUpdate ? "Editar Pacote de Novidades" : "Novo Pacote de Novidades") + " ")])]), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-light font-weight-bolder font-size-sm mr-2",
    attrs: {
      "to": {
        name: 'novidadesAdmin'
      }
    }
  }, [_vm._v(" Voltar ")]), _c('button', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    attrs: {
      "disabled": _vm.salvando
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm.salvando ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Salvar pacote ")], 1)], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_vm.carregando ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando...")])], 1) : _c('div', [_c('h5', {
    staticClass: "font-weight-bolder text-dark mb-5"
  }, [_vm._v("Dados do Pacote")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título *",
      "label-for": "titulo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "titulo",
      "placeholder": "Ex: Novidades de Maio no Sistema Nuts",
      "state": _vm.form.titulo ? null : false
    },
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  }), _c('b-form-invalid-feedback', [_vm._v("O título é obrigatório.")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Versão",
      "label-for": "versao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "versao",
      "placeholder": "Ex: 2.5.0"
    },
    model: {
      value: _vm.form.versao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "versao", $$v);
      },
      expression: "form.versao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição curta",
      "label-for": "descricao_curta"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "descricao_curta",
      "placeholder": "Resumo exibido no card do dashboard"
    },
    model: {
      value: _vm.form.descricao_curta,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao_curta", $$v);
      },
      expression: "form.descricao_curta"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição completa",
      "label-for": "descricao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "descricao",
      "rows": "4",
      "placeholder": "Descrição detalhada do pacote"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de publicação",
      "label-for": "data_publicacao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "data_publicacao",
      "type": "date"
    },
    model: {
      value: _vm.form.data_publicacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_publicacao", $$v);
      },
      expression: "form.data_publicacao"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-center pt-4",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.publicado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "publicado", $$v);
      },
      expression: "form.publicado"
    }
  }, [_vm._v(" Publicado ")])], 1), _c('b-col', {
    staticClass: "d-flex align-items-center pt-4",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.destacar_dashboard,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "destacar_dashboard", $$v);
      },
      expression: "form.destacar_dashboard"
    }
  }, [_vm._v(" Destacar no dashboard ")])], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.exibir_modal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "exibir_modal", $$v);
      },
      expression: "form.exibir_modal"
    }
  }, [_vm._v(" Exibir modal ao entrar ")])], 1)], 1), _c('hr', {
    staticClass: "my-8"
  }), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-5"
  }, [_c('h5', {
    staticClass: "font-weight-bolder text-dark mb-0"
  }, [_vm._v("Itens do Pacote")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bolder font-size-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarItem
    }
  }, [_vm._v(" + Adicionar item ")])]), _vm.form.itens.length === 0 ? _c('div', {
    staticClass: "text-center text-muted py-8"
  }, [_vm._v(" Nenhum item adicionado. Clique em \"+ Adicionar item\" para começar. ")]) : _vm._e(), _vm._l(_vm.form.itens, function (item, index) {
    return _c('div', {
      key: item._key,
      staticClass: "card border mb-4"
    }, [_c('div', {
      staticClass: "card-header py-3 d-flex align-items-center justify-content-between"
    }, [_c('span', {
      staticClass: "font-weight-bolder"
    }, [_vm._v(" Item " + _vm._s(index + 1) + " "), item.titulo ? _c('span', {
      staticClass: "text-muted ml-2"
    }, [_vm._v("— " + _vm._s(item.titulo))]) : _vm._e()]), _c('div', [_c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-icon btn-sm btn-light-danger",
      attrs: {
        "type": "button",
        "title": "Remover item"
      },
      on: {
        "click": function click($event) {
          return _vm.removerItem(index);
        }
      }
    }, [_c('TrashCan', {
      attrs: {
        "size": 14
      }
    })], 1)])]), _c('div', {
      staticClass: "card-body"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "md": "8"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Título do item *",
        "label-for": "item-titulo-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-titulo-".concat(index),
        "placeholder": "Ex: Orçamentos com fotos de produtos"
      },
      model: {
        value: item.titulo,
        callback: function callback($$v) {
          _vm.$set(item, "titulo", $$v);
        },
        expression: "item.titulo"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Tipo",
        "label-for": "item-tipo-".concat(index)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.tipo,
        expression: "item.tipo"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "item-tipo-".concat(index)
      },
      on: {
        "change": function change($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(item, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, _vm._l(_vm.tiposItem, function (t) {
      return _c('option', {
        key: t.value,
        domProps: {
          "value": t.value
        }
      }, [_vm._v(" " + _vm._s(t.label) + " ")]);
    }), 0)])], 1)], 1), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Descrição curta",
        "label-for": "item-desc-curta-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-desc-curta-".concat(index),
        "placeholder": "Breve descrição da novidade"
      },
      model: {
        value: item.descricao_curta,
        callback: function callback($$v) {
          _vm.$set(item, "descricao_curta", $$v);
        },
        expression: "item.descricao_curta"
      }
    })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Descrição completa",
        "label-for": "item-desc-completa-".concat(index)
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "id": "item-desc-completa-".concat(index),
        "rows": "3",
        "placeholder": "Detalhes da novidade"
      },
      model: {
        value: item.descricao,
        callback: function callback($$v) {
          _vm.$set(item, "descricao", $$v);
        },
        expression: "item.descricao"
      }
    })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Ícone",
        "label-for": "item-icone-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-icone-".concat(index),
        "placeholder": "Ex: star, check-circle"
      },
      model: {
        value: item.icone,
        callback: function callback($$v) {
          _vm.$set(item, "icone", $$v);
        },
        expression: "item.icone"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Link de vídeo",
        "label-for": "item-video-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-video-".concat(index),
        "placeholder": "https://youtube.com/..."
      },
      model: {
        value: item.video_url,
        callback: function callback($$v) {
          _vm.$set(item, "video_url", $$v);
        },
        expression: "item.video_url"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Link de documentação",
        "label-for": "item-doc-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-doc-".concat(index),
        "placeholder": "https://docs.nuts..."
      },
      model: {
        value: item.documentacao_url,
        callback: function callback($$v) {
          _vm.$set(item, "documentacao_url", $$v);
        },
        expression: "item.documentacao_url"
      }
    })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Ordem",
        "label-for": "item-ordem-".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "item-ordem-".concat(index),
        "type": "number",
        "min": "1"
      },
      model: {
        value: item.ordem,
        callback: function callback($$v) {
          _vm.$set(item, "ordem", _vm._n($$v));
        },
        expression: "item.ordem"
      }
    })], 1)], 1)], 1)], 1)]);
  })], 2)]), !_vm.carregando ? _c('div', {
    staticClass: "card-footer d-flex justify-content-end"
  }, [_c('router-link', {
    staticClass: "btn btn-light mr-3",
    attrs: {
      "to": {
        name: 'novidadesAdmin'
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark font-weight-bolder",
    attrs: {
      "disabled": _vm.salvando
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm.salvando ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Salvar pacote ")], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };